@if (order$ | async; as order) {
  <elder-basic-pane-layout class="full">
    <elder-pane>
      <elder-pane-header>
        <elder-pane-title> {{ 'context.order' | translate }} {{ order.id }} </elder-pane-title>
        <elder-pane-actions>
          <button mat-icon-button [matMenuTriggerFor]="orderMenu" disabled>
            <mat-icon>more_vert</mat-icon>
            <mat-menu #orderMenu="matMenu"> </mat-menu>
          </button>
        </elder-pane-actions>
      </elder-pane-header>
      <elder-pane-content>
        <div class="flex layout-row">
          <!-- Main Detail -->
          <div class="flex p-sm layout-col">
            <h4 class="text-title-medium">{{ 'context.overview' | translate }}</h4>
            <div class="layout-row place-space-between">
              <mat-form-field elderFormFieldLabel class="p-sm">
                <mat-label>{{ 'orders.facility' | translate }}</mat-label>
                <input
                  matInput
                  type="text"
                  name="facility"
                  [value]="order.company + '/' + order.facility"
                  readonly
                />
              </mat-form-field>
              <mat-form-field elderFormFieldLabel class="p-sm">
                <mat-label>{{ 'orders.prod.confirmation' | translate }}</mat-label>
                <input
                  matInput
                  type="text"
                  name="state"
                  readonly
                  [value]="'order_confirmation_state.' + order.confirmationState | translate"
                />
              </mat-form-field>
              <mat-form-field elderFormFieldLabel class="p-sm">
                <mat-label>{{ 'orders.type' | translate }}</mat-label>
                <input matInput type="text" name="type" [value]="order.groupId" readonly />
              </mat-form-field>
            </div>
            <div class="layout-row space-between">
              <mat-form-field elderFormFieldLabel class="p-sm">
                <mat-label>{{ 'context.priority' | translate }}</mat-label>
                <input
                  matInput
                  type="text"
                  name="orderPriority"
                  readonly
                  [value]="'orders.orderPriority.' + order.orderPriority | translate"
                />
              </mat-form-field>
              <mat-form-field elderFormFieldLabel class="p-sm">
                <mat-label>{{ 'context.production' | translate }}</mat-label>
                <input
                  matInput
                  type="text"
                  name="completionState"
                  [value]="'work_order_completion_state.' + order.completionState | translate"
                  readonly
                />
              </mat-form-field>
              <mat-form-field elderFormFieldLabel class="p-sm">
                <mat-label>{{ 'context.deliveryNote' | translate }}</mat-label>
                <input
                  matInput
                  type="text"
                  name="deliveryNoteRef"
                  [value]="order.shipment?.deliveryNoteRef?.number"
                  readonly
                />
              </mat-form-field>
            </div>
            <div class="layout-col">
              <mat-form-field elderFormFieldLabel class="p-sm">
                <mat-label>{{ 'context.description' | translate }}</mat-label>
                <input
                  matInput
                  type="text"
                  name="description"
                  [value]="order.description"
                  readonly
                />
              </mat-form-field>
              <mat-form-field elderFormFieldLabel class="p-sm">
                <mat-label>{{ 'orders.projectDescription' | translate }}</mat-label>
                <input
                  matInput
                  type="text"
                  name="projectDescription"
                  [value]="order.projectDescription"
                  readonly
                />
              </mat-form-field>
            </div>
          </div>
          <div class="flex-20 layout-col">
            <h4 class="text-title-medium">{{ 'context.labels' | translate }}</h4>
            <mat-chip-set class="layout-row">
              @for (label of order.labels; track label) {
                <mat-chip highlighted>{{ label }}</mat-chip>
              }
            </mat-chip-set>
          </div>
          <div class="flex layout-col">
            <h4 class="text-title-medium">{{ 'deliveries.plannedDeliveries' | translate }}</h4>
            <elder-table class="flex" dense [data]="deliveries$ | async">
              <ng-container matColumnDef="delivery">
                <th mat-header-cell *matHeaderCellDef class="width-30p">
                  {{ 'deliveries.delivery' | translate }}
                </th>
                <td mat-cell *matCellDef="let row">
                  <div class="layout-col">
                    <span>{{ row.id }}</span>
                    <span class="mat-caption">Ref: {{ row.orderReferenceNumber }}</span>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="facility">
                <th mat-header-cell *matHeaderCellDef class="width-10p">
                  {{ 'context.facility' | translate }}
                </th>
                <td mat-cell *matCellDef="let row">{{ row.facilityId }}</td>
              </ng-container>
              <ng-container matColumnDef="targetWeight">
                <th mat-header-cell *matHeaderCellDef class="width-15p">
                  {{ 'context.targetWeight' | translate }}
                </th>
                <td mat-cell *matCellDef="let row">{{ row.targetWeight | elderQuantity }}</td>
              </ng-container>
              <ng-container matColumnDef="shipment">
                <th mat-header-cell *matHeaderCellDef class="width-30p">
                  {{ 'shipments.shipment' | translate }}
                </th>
                <td mat-cell *matCellDef="let row">{{ row.shipmentId }}</td>
              </ng-container>
              <ng-container matColumnDef="priority">
                <th mat-header-cell *matHeaderCellDef class="width-15p">
                  {{ 'context.priority' | translate }}
                </th>
                <td mat-cell *matCellDef="let row">{{ row.priority }}</td>
              </ng-container>
            </elder-table>
          </div>
        </div>
      </elder-pane-content>
    </elder-pane>
  </elder-basic-pane-layout>
}
